if(!customElements.get('text-banner-collapsible')) {
  class TextBannerCollapsible extends HTMLElement {
    constructor() {
      super();
      this.bindOnButtonClick = this.onButtonClick.bind(this);
      this.debounceSetCollapsible = debounce(this.setCollapsible.bind(this), 200);
    }

    connectedCallback() {
      this.button = this.querySelector('.text-banner-collapsible__button');
      this.content = this.querySelector('.text-banner-collapsible__content');

      if (!this.button || !this.content) return;

      this.setCollapsible();
      requestAnimationFrame(() => {
        this.button.addEventListener('click', this.bindOnButtonClick);
        window.addEventListener('resize', this.debounceSetCollapsible);
      })
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.bindOnButtonClick);
      window.removeEventListener('resize', this.debounceSetCollapsible);
    }

    setCollapsible() {
      this.classList.remove('loaded');
      this.maxHeight = this.content.getBoundingClientRect().height;
      this.content.style.setProperty('--max-height', `${this.maxHeight}px`);
      this.classList.add('loaded');
    }

    onButtonClick() {
      if (this.hasAttribute('open')) {
        this.removeAttribute('open');
        this.button.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('aria-hidden', 'true');
      }
      else {
        this.setAttribute('open', '');
        this.button.setAttribute('aria-expanded', 'true');
        this.content.setAttribute('aria-hidden', 'false');
      }
    }
  }

  customElements.define('text-banner-collapsible', TextBannerCollapsible)
}